module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discussion"
  }, [_c('div', {
    staticClass: "conversationInfoContainer"
  }, [_c('div', {
    staticClass: "conversationInfo"
  }, [_vm._l((_vm.users), function(user) {
    return _c('vue-object-img', {
      key: user.id,
      attrs: {
        "object": user
      }
    })
  }), _vm._v(_vm._s(_vm._f("users")(_vm.users)))], 2)]), (_vm.conversation) ? _c('div', {
    ref: "messages",
    staticClass: "messages"
  }, [_c('div', {
    staticClass: "waiting text-center text-muted"
  }, [_vm._v(_vm._s(_vm.$t('chat.discussion.with')) + " " + _vm._s(_vm._f("users")(_vm.users))), _c('br'), _c('br'), _vm._l((_vm.users), function(user) {
    return _c('vue-object-img', {
      key: user.id,
      attrs: {
        "object": user
      }
    })
  }), _c('br'), _c('br'), (_vm.status === _vm.STATUS.LOADING) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _vm._e(), (_vm.status === _vm.STATUS.LOADED && _vm.messages.length == 0) ? [_vm._v(_vm._s(_vm.$t('chat.discussion.beTheFirst')))] : _vm._e()], 2), _vm._l((_vm.messages), function(message) {
    return (_vm.conversation) ? _c('div', {
      key: message.id,
      staticClass: "message",
      class: {
        inverted: message.sender.id === _vm.user.id
      }
    }, [_c('vue-object-img', {
      attrs: {
        "object": message.sender
      }
    }), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("unixtimeTo")(message.time, 'LLL')))]), _c('div', {
      staticClass: "text"
    }, [_c('embed-text', {
      attrs: {
        "options": _vm.embedOptions
      },
      on: {
        "done": _vm.goToBottom
      }
    }, [_vm._v(_vm._s(message.text))])], 1), _c('br')], 1) : _vm._e()
  }), (_vm.isWriting) ? _c('div', {
    staticClass: "isWriting"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("conversations.isWriting")))])]) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "answer"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMessage),
      expression: "newMessage"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.$t("chat.discussion.messagePlaceholder")
    },
    domProps: {
      "value": (_vm.newMessage)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendMessage($event)
      },
      "focus": _vm.takeInput,
      "blur": _vm.releaseInput,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMessage = $event.target.value
      }
    }
  }), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.$t('globals.send')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117e1e76","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat/ChatConversation.vue
// module id = 994
// module chunks = 0 1